// removed by extract-text-webpack-plugin
module.exports = {"linkCard":"src-components-linkCard----linkCard-module---linkCard---2KxwL","header":"src-components-linkCard----linkCard-module---header---eNrXt","icon":"src-components-linkCard----linkCard-module---icon---3hxXy","iconWrapper":"src-components-linkCard----linkCard-module---iconWrapper---1wMAl","link":"src-components-linkCard----linkCard-module---link---325qi","mobileLink":"src-components-linkCard----linkCard-module---mobileLink---3KNvZ","dark":"src-components-linkCard----linkCard-module---dark---2bNZI"};


//////////////////
// WEBPACK FOOTER
// ./src/components/linkCard/linkCard.module.scss
// module id = 288
// module chunks = 95715928098905 199248266171276